// Reopening a finished Chat-built App from its message (the App canvas, not the Activity view).
// Namespace `app-reopen`; owner: T2-UI1. English is the source; the other languages are DES2 translations.
import type { NamespaceCatalog } from '@/i18n/ns';

const en = {
  openApp: 'Open App',
};
export type AppReopenCopyKey = keyof typeof en;

export const appReopenCopy: NamespaceCatalog<AppReopenCopyKey> = {
  en,
  sv: {
    openApp: 'Öppna appen',
  },
  da: {
    openApp: 'Åbn appen',
  },
  de: {
    openApp: 'App öffnen',
  },
  fr: {
    openApp: 'Ouvrir l’app',
  },
  es: {
    openApp: 'Abrir app',
  },
  it: {
    openApp: 'Apri App',
  },
  pt: {
    openApp: 'Abrir App',
  },
  nl: {
    openApp: 'App openen',
  },
  fi: {
    openApp: 'Avaa sovellus',
  },
  et: {
    openApp: 'Ava rakendus',
  },
  bg: {
    openApp: 'Отваряне на приложението',
  },
  cs: {
    openApp: 'Otevřít aplikaci',
  },
  sk: {
    openApp: 'Otvoriť aplikáciu',
  },
  pl: {
    openApp: 'Otwórz aplikację',
  },
  hr: {
    openApp: 'Otvori aplikaciju',
  },
  sl: {
    openApp: 'Odpri aplikacijo',
  },
  hu: {
    openApp: 'Alkalmazás megnyitása',
  },
  el: {
    openApp: 'Άνοιγμα εφαρμογής',
  },
  ro: {
    openApp: 'Deschide aplicația',
  },
  lt: {
    openApp: 'Atidaryti programėlę',
  },
  lv: {
    openApp: 'Atvērt lietotni',
  },
  ga: {
    openApp: 'Oscail an aip',
  },
  mt: {
    openApp: 'Iftaħ l-App',
  },
};
export default appReopenCopy;
